if (!window.customElements.get('hero-parallax')) {

  class HeroParallax extends HTMLElement {
    constructor() {
      super();
      this.asset = null;
      this.section = null;
      this.sectionHeight = null;
      this.scrollAnimation = null;
      this.resizeTimeout = null;
      this.motion = null;
    }

    connectedCallback() {
      // Find the hero asset element
      this.asset = this.querySelector('.hero__asset');
      
      if (!this.asset) {
        console.warn('HeroParallax: No .hero__asset element found');
        return;
      }

      this.handleResize();

      window.addEventListener('resize', this.handleResize.bind(this));

      // Wait for Motion.dev to be ready
      whenReady('motion', (motion) => {
        this.motion = motion;
        
        // Ensure section height is calculated before initializing parallax
        setTimeout(() => {
          this.initParallax();
          // console.log('init <hero parallax />');
        }, 200); // Give time for handleResize to complete
      });

    }

    handleResize() {
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }

      this.resizeTimeout = setTimeout(() => {
        this.section = this.closest('section');
        this.sectionHeight = this.section.offsetHeight;
      }, 150);
    }

    initParallax() {

      if(navigator.maxTouchPoints > 0) {
        return;
      }

      // Get the section element (parent of this component)
      const section = this.closest('section');
      
      if (!section) {
        console.warn('HeroParallax: No parent section found');
        return;
      }

      // Ensure section height is calculated
      if (!this.sectionHeight || this.sectionHeight <= 0) {
        this.sectionHeight = section.offsetHeight;
      }

      // Validate section height
      if (!this.sectionHeight || !isFinite(this.sectionHeight) || this.sectionHeight <= 0) {
        console.warn('HeroParallax: Invalid section height, using fallback');
        this.sectionHeight = window.innerHeight; // Fallback to viewport height
      }

      // Set initial position
      this.motion.animate(this.asset, {
        y: 0
      }, { duration: 0 });

      // Create the parallax animation using Motion.dev scroll
      const maxOffset = 200; // Maximum pixels to move down
      const scrollDistance = Math.round(this.sectionHeight * 1.25);

      // Validate scrollDistance to ensure it's finite
      if (!isFinite(scrollDistance) || scrollDistance <= 0) {
        console.warn('HeroParallax: Invalid scroll distance, skipping animation');
        return; // Skip animation if we can't calculate proper distance
      }

      // Use the correct Motion.dev scroll syntax
      try {
        this.scrollAnimation = this.motion.scroll(
          this.motion.animate(this.asset, {
            y: [0, maxOffset]
          }),
          {
            target: section,
            offset: [`0px`, `${scrollDistance}px`]
          }
        );
      } catch (error) {
        console.warn('HeroParallax: Failed to create scroll animation:', error);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize.bind(this));
      // Clean up scroll animation when component is removed
      if (this.scrollAnimation) {
        this.scrollAnimation.stop();
      }
    }
  }
  
  customElements.define('hero-parallax', HeroParallax);

}